// src/utils/authService.js

import axios from 'axios';

export const refreshAccessToken = async () => {
  try {
    const response = await axios.post('https://api.stemverse.app/auth/refresh', {}, { withCredentials: true }); //http://localhost:3500/auth/refresh'
    return response.data.accessToken;
  } catch (error) {
    console.error('Error refreshing token:', error);
    throw error;
  }
};

export const logoutUser = async () => {
  try {
    const sessionId = localStorage.getItem("sessionId");
    if (sessionId) {
      await axios.post('https://api.stemverse.app/auth/logout', { sessionId }, { withCredentials: true }).catch(() => { }); //http://localhost:3500/auth/logout
    }
  } catch (error) {
    console.error('Error during logout:', error);
  } finally {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('userRole');
    localStorage.removeItem('currentProjectId');
    localStorage.removeItem('currentProjectOriginalTitle');
  }
};
